import { styled } from 'styled-components';

export const CheckboxInput = styled.div`
  border-radius: 10px;
  display: flex;
  width: 100%;
  min-height: 50px;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: 1px solid #dccbc5;
  background: #fffdfc;
  user-select: none;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
`;
